import { INotifyManagerInjectable } from '@src/slide/application/service/notify-manager/core/notify-manager.interface';

export class NotifyManagerInjectable implements INotifyManagerInjectable {
    public get customNodeStyle() {
        const style: Partial<CSSStyleDeclaration> = {};
        return style;
    }
}
